// tslint:disable
/**
 * Settings storage API
 * Key-value settings storage API for: - Global system settings (only for root) - Personal user settings - Company settings 
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { Setting } from '../models';
/**
 * GlobalApi - axios parameter creator
 * @export
 */
export const GlobalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} settings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalSettings(settings: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'settings' is not null or undefined
            if (settings === null || settings === undefined) {
                throw new RequiredError('settings','Required parameter settings was null or undefined when calling deleteGlobalSettings.');
            }
            const localVarPath = `/settings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (settings) {
                localVarQueryParameter['settings'] = settings.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [settings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalSettings(settings?: Array<string>, options: any = {}): RequestArgs {
            const localVarPath = `/settings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (settings) {
                localVarQueryParameter['settings'] = settings.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<Setting>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGlobalSettings(body: Array<Setting>, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling putGlobalSettings.');
            }
            const localVarPath = `/settings`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalApi - functional programming interface
 * @export
 */
export const GlobalApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} settings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalSettings(settings: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = GlobalApiAxiosParamCreator(configuration).deleteGlobalSettings(settings, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} [settings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalSettings(settings?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Setting>> {
            const localVarAxiosArgs = GlobalApiAxiosParamCreator(configuration).getGlobalSettings(settings, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<Setting>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGlobalSettings(body: Array<Setting>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Setting>> {
            const localVarAxiosArgs = GlobalApiAxiosParamCreator(configuration).putGlobalSettings(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * GlobalApi - factory interface
 * @export
 */
export const GlobalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {Array<string>} settings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalSettings(settings: Array<string>, options?: any) {
            return GlobalApiFp(configuration).deleteGlobalSettings(settings, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} [settings] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalSettings(settings?: Array<string>, options?: any) {
            return GlobalApiFp(configuration).getGlobalSettings(settings, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<Setting>} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGlobalSettings(body: Array<Setting>, options?: any) {
            return GlobalApiFp(configuration).putGlobalSettings(body, options)(axios, basePath);
        },
    };
};

/**
 * GlobalApi - object-oriented interface
 * @export
 * @class GlobalApi
 * @extends {BaseAPI}
 */
export class GlobalApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} settings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalApi
     */
    public deleteGlobalSettings(settings: Array<string>, options?: any) {
        return GlobalApiFp(this.configuration).deleteGlobalSettings(settings, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [settings] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalApi
     */
    public getGlobalSettings(settings?: Array<string>, options?: any) {
        return GlobalApiFp(this.configuration).getGlobalSettings(settings, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<Setting>} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalApi
     */
    public putGlobalSettings(body: Array<Setting>, options?: any) {
        return GlobalApiFp(this.configuration).putGlobalSettings(body, options)(this.axios, this.basePath);
    }

}
